import apiClient from './apiClient'


const getProjects = (tenant, seasonId, skip, take, search, orderBy, desc, onlyThisManager) => {
  const params = {
    seasonId,
    skip,
    take,
    keyword: search,
    orderBy,
    desc,
    onlyThisManager
  }
  return apiClient.get(`/${tenant}/Project`, { params })
}

const getShortProjects = (tenant) => {
  return apiClient.get(`/${tenant}/Project/Short`)
}

const getProject = (tenant, id) => {
  return apiClient.get(`/${tenant}/Project/${id}`)
}

const createProject = (tenant, project) => {
  return apiClient.post(`/${tenant}/Project`, project)
}

const updateProject = (tenant, id, project) => {
  return apiClient.put(`/${tenant}/Project/${id}`, project)
}

const deleteProject = (tenant, id, confirmTitle) => {
  const params = {
    confirmTitle
  }
  return apiClient.delete(`/${tenant}/Project/${id}`, { params })
}

const setProjectScheme = (tenant, projectId, schemeId) => {
  schemeId = schemeId || ''
  return apiClient.put(`/${tenant}/Project/${projectId}/scheme/${schemeId}`)
}

const setProjectIsPublic = (tenant, projectId, isPublic) => {
  return apiClient.put(`/${tenant}/Project/${projectId}/Public/${isPublic}`)
}

const setProjectStatusId = (tenant, projectId, statusId) => {
  return apiClient.put(`/${tenant}/Project/${projectId}/Status/${statusId}`)
}

const setProjectBookingStatusId = (tenant, projectId, bookingStatusId) => {
  return apiClient.put(`/${tenant}/Project/${projectId}/Bookingstatus/${bookingStatusId}`)
}


export default {
  getProjects,
  getShortProjects,
  getProject,
  createProject,
  updateProject,
  deleteProject,
  setProjectScheme,
  setProjectIsPublic,
  setProjectStatusId,
  setProjectBookingStatusId
}
